import { Injectable } from '@angular/core';
import axios from 'axios';
import { environment } from 'src/environments/environment';

type EhazSsoResponse = {
  payee_case_id: string;
  client_id: string;
}

@Injectable({
  providedIn: 'root'
})
export class EhazSsoApiService {
  async eHazSso(eHazToken: string): Promise<EhazSsoResponse> {
    const url = `${environment.baseUrl}/api/ehaz/sso/case/${eHazToken}`;
    const response = await axios.get<EhazSsoResponse>(url);
    return response.data;
  }
}
